var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',_vm._g({attrs:{"mode":"date","is-dark":"","is-inline":"","popover":{
    placement: _vm.$screens({ sm: 'auto' }),
    visibility: 'click',
  },"update-on-input":false,"value":_vm.value,"available-dates":{ start: _vm.minDate }},scopedSlots:_vm._u([{key:"default",fn:function({ inputValue, inputEvents }){return [_c('CustomInput',_vm._g({attrs:{"placeholder":_vm.label,"label":"00/00/0000","icon":"mdi-calendar-month-outline font-size-1-3","value":inputValue,"readonly":true,"pointer":true}},inputEvents))]}}])},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }